

export default class WorkflowStep

{
    constructor(gcid, workflowStep, lastWorkflowStep, lastUpdated, lastUpdatedBy)
    {
        this.gcid = gcid || "";
        this.workflowStep = workflowStep || "";
        this.lastWorkflowStep = lastWorkflowStep || "";
        this.lastUpdated = lastUpdated || "";
        this.lastUpdatedBy = lastUpdatedBy || "";
    }
}